<template>
  <div class="sitelist">
    <top-nav ref="TopNav"></top-nav>
    <!--头部-->
    <!--<van-nav-bar title="我的收货地址" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
      <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
    <!--</van-nav-bar>-->
    <!--地址-->
    <div style="padding-top: 0" class="van-content">
      <div class="nodata text-cent" v-if="nodata && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg1.png"/>
        </P>
        <p class="text">还没有添加地址~</p>
      </div>
      <van-cell-swipe :right-width="0" :left-width="0" v-if="datas != ''" v-for="(items,index) in datas" :key="items.id">
        <!-- <span slot="left">选择</span> -->
        <van-cell-group>
          <div class="van-cell">
            <div class="sitebox">
              <div class="van-address-list__name">{{ items.name }} {{ items.mobile }}</div>
              <div class="van-address-list__address site-address">收货地址：{{ items.addressInfo }}{{ items.address }}</div>
              <div class="text-right site-btnbox">
                <!--<span v-if="items.moren == 0">设为默认</span>-->
                <div data-v-8976be6e="" class="float-left van-checkbox" @click="morenPlay(items.id,index,items.moren)">
                  <i class="van-icon van-icon-success van-checkbox__icon van-checkbox--round" :class="{'van-checkbox--checked':items.moren == 1}"></i>
                  <span class="van-checkbox__label">{{ items.moren == 1?'默认地址':'设为默认' }}</span>
                </div>
                <span @click="removeSite(items.id,index)"><i class="van-icon iconfont icon-shanchu"></i>删除</span>
                <router-link tag="span" :to="{path:'/user/mysite/amendsite',query:{id:items.id}}"><i class="van-icon iconfont icon-bianji-"></i>编辑</router-link>
              </div>
            </div>
          </div>
        </van-cell-group>
        <!-- <span slot="right"><button class="clearbtn theme-bd theme-bg" @click="removeSite(items.id,index)">删除</button></span> -->
      </van-cell-swipe>
      <!--<van-address-list v-model="chosenAddressId"  @edit="amendSite" :list="siteList" v-if="siteList[0].id != ''">
      </van-address-list>-->
      <van-cell-group v-else>
        <van-cell>添加收货地址</van-cell>
      </van-cell-group>
    </div>
    <div  class="addSiteBtn">
      <!--<router-link to="/user/mysite/addsite"><van-button style="font-size: 16px" class="theme-bd theme-bg">添加收货地址</van-button></router-link>-->
      <van-button @click="addsites()" style="font-size: 16px" class="theme-bd theme-bg">添加收货地址</van-button>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "mysite",
    components: {
      TopNav
    },
    data () {
      return {
        datas:'',
        nodata: false,
        checked:'',
        length:0,
        siteList: [
            {
              id: '',
              name: '',
              tel: '',
              address: ''
            }
          ]
        }
    },
    methods:{
      amendSite:function (item, index) {
        this.$router.push({path:'/user/mysite/amendsite',query:{id:item.id}})
      },
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      addsites:function () {
          if(this.length<5){
            this.$router.push({path:'/user/mysite/addsite'})
          }else{
            this.$toast('最多保存5条收货信息')
          }

      },
      removeSite:function (id,index) {
        this.$dialog.confirm({
          message: '确定要删除此收货地址吗？'
        }).then(() => {
          var isUser = localStorage.getItem("BLHuser")
          this.$api.post('WebApi/Member/Address/delAddr', {token:isUser,id:id}, res => {
            if(res.data.errCode == '0000'){
              this.datas.splice(index,1)
            }else{
              this.$toast({
                message:res.data.desc,
                duration:500
              })
            }
          })
        }).catch(() => {
          // on cancel
        });
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        this.$api.post('WebApi/Member/Address/index', {token:isUser}, res => {
          if(res.data.data != null){
            this.datas = res.data.data
            this.checked = res.data.data.moren
            this.length=res.data.data.length
          }
        })
      },
      morenPlay:function (id,index,moren) {
        if(moren != 1){
          var isUser = localStorage.getItem("BLHuser")
          this.$api.post('WebApi/Member/Address/setDefaultAddr', {token:isUser,id:id}, res => {
            if(res.data.errCode == '0000'){
              $.each(this.datas,function (index,items) {
                items.moren = 0
              })
              this.datas[index].moren = 1
              setTimeout(() => {
                history.back(-1);
              },1000);
            }else{
              this.$toast({
                message:res.data.desc,
                duration:500
              })
            }
          })
        }

      }
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .sitelist{
    .sitebox{
      width: 100%;
    }
    .clearbtn {
      width: 65px;
      height: 100%;
    }
    .site-address{
      padding: 10px 0;
      border-bottom: 1px solid #f2f2f2;
    }
    .site-btnbox{
      padding-top: 5px;
      .iconfont{
        vertical-align: middle;
        font-size: 1.8rem;
        margin-right: 5px;
        margin-left: 10px;
      }
    }
    .addSiteBtn{
      border-right: 0;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      button{
        border-radius: 6px;
        border: none;
        width: 100%;
        float: left;
      }
    }
    .popupleft{
      width: 100%;
      height: 100%;
    }
    .van-card{
      margin: 15px 0;
    }
    .van-card,.van-cell-group, .van-cell{
      background-color: #fff;
    }
    .van-cell:not(:last-child)::after{
      border-bottom-width:0;
    }
    .van-checkbox__icon{
      font-size: 12px;
      color: transparent;
      text-align: center;
      border: 1px solid #aaa;
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      border-radius: 50%;
      line-height: 18px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/mysite.vue